<div class="wb-banners" layout="row">
  <md-card class="wb-banner-group" ng-repeat="bannerGroup in WbBanners.bannerGroups">
    <a class="wb-banner-item" ng-repeat="banner in bannerGroup" ng-class="{'wb-banner-item-active': banner.active}" ng-href="{{banner.link | wbUrlDecode}}" target="_blank">
      <img ng-src="{{banner.position === 'left' ? banner.images[1].url : banner.images[0].url}}">
    </a>
  </md-card>
</div>
